import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Estimator from './pages/Estimator';
import EstimatorFullHome from './pages/EstimatorFullHome';
import EstimatorKitchen from './pages/EstimatorKitchen';
import EstimatorWardrobe from './pages/EstimatorWardrobe';
import HireDesigner from './pages/HireDesigner';
import GetQuote from './pages/GetQuote';
import Portfolio from './pages/Portfolio';
import './App.css';
import './styles/Footer.css';
import './styles/Home.css';
import './styles/PageTemplate.css';
import './styles/Portfolio.css';
import Testimonials from './components/Testimonials';
import AboutSection from './components/AboutSection';
import Contact from './pages/Contact';

function PageTitleManager() {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname;
    let page = 'Home';
    let description = 'Astro Interiors offers bespoke home interiors, kitchens, wardrobes, and full-home design solutions. Get expert consultation and transparent estimates.';
    if (path === '/') page = 'Home';
    else if (path.startsWith('/services')) page = 'Services';
    else if (path === '/estimator/full-home') page = 'Full Home Estimator';
    else if (path === '/estimator/kitchen') page = 'Kitchen Estimator';
    else if (path === '/estimator/wardrobe') page = 'Wardrobe Estimator';
    else if (path.startsWith('/estimator')) page = 'Estimator';
    else if (path.startsWith('/reviews')) page = 'Reviews';
    else if (path.startsWith('/portfolio')) page = 'Portfolio';
    else if (path.startsWith('/about')) page = 'About';
    else if (path.startsWith('/get-quote')) page = 'Get Quote';
    else if (path.startsWith('/contact')) page = 'Contact';
    else if (path.startsWith('/hire-designer')) page = 'Hire an Interior Designer';
    // Title
    document.title = `Astro Interiors - ${page}`;

    // Per-route descriptions (optional fine-tuning)
    switch (page) {
      case 'Services':
        description = 'Explore Astro Interiors services: modular kitchens, wardrobes, and complete interior design—with light-touch Vastu and zodiac-inspired guidance.';
        break;
      case 'Estimator':
        description = 'Use our estimator to get a quick, transparent cost estimate—with optional Vastu/zodiac tips to align comfort and flow.';
        break;
      case 'Full Home Estimator':
        description = 'Estimate the cost for full home interiors—living, bedrooms, kitchen, and more—with light-touch Vastu and zodiac suggestions.';
        break;
      case 'Kitchen Estimator':
        description = 'Instantly estimate your modular kitchen cost based on size, layout, and finish—with light-touch Vastu and zodiac suggestions.';
        break;
      case 'Wardrobe Estimator':
        description = 'Estimate custom wardrobe pricing by size, shutters, finishes, and internal layouts—with light-touch Vastu and zodiac suggestions.';
        break;
      case 'Portfolio':
        description = 'See Astro Interiors portfolio—real projects showcasing our design quality and execution.';
        break;
      case 'Reviews':
        description = 'Read testimonials and reviews from Astro Interiors customers.';
        break;
      case 'About':
        description = 'Learn about Astro Interiors—our design philosophy and commitment to quality.';
        break;
      case 'Get Quote':
        description = 'Request a personalized quote for your interior project from Astro Interiors.';
        break;
      case 'Contact':
        description = 'Contact Astro Interiors for personalized design consultations, project inquiries, and expert guidance on your home transformation.';
        break;
      case 'Hire an Interior Designer':
        description = 'Hire expert interior designers from Astro Interiors for bespoke home and office interior design solutions tailored to your style and needs.';
        break;
      default:
        break;
    }

    // Meta description
    const descTag = document.querySelector('meta[name="description"]');
    if (descTag) {
      descTag.setAttribute('content', description);
    }

    // Open Graph
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', `Astro Interiors - ${page}`);
    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', description);

    // Twitter
    const twTitle = document.querySelector('meta[name="twitter:title"]');
    if (twTitle) twTitle.setAttribute('content', `Astro Interiors - ${page}`);
    const twDesc = document.querySelector('meta[name="twitter:description"]');
    if (twDesc) twDesc.setAttribute('content', description);

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      const url = `${window.location.origin}${path}`;
      canonical.setAttribute('href', url);
    }
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <PageTitleManager />
      <div className="App">
        <Navbar />
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/*" element={<Services />} />
            <Route path="/estimator" element={<Estimator />} />
            <Route path="/estimator/full-home" element={<EstimatorFullHome />} />
            <Route path="/estimator/kitchen" element={<EstimatorKitchen />} />
            <Route path="/estimator/wardrobe" element={<EstimatorWardrobe />} />

            <Route path="/reviews" element={<Testimonials />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/about" element={<AboutSection />} />
            <Route path="/get-quote" element={<GetQuote />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/hire-designer" element={<HireDesigner />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

